import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/reports/assetUtilizationReport'
import Component from 'components/Reports/AssetUtilizationReport'

export default createListViewContainer({ actions, selectors: selectors.assetUtilizationReport })(Component)
